import { externalNotif } from './modules/Notif/services/externalNotif';

const config = {
  onUpdate: registration => {
    externalNotif();
  },
};

export default config;
